module.exports = __webpack_public_path__ + "static/media/1.6810bb83.mp3";